'use strict';

exports.__esModule = true;
exports.default = {
  STANDARD: 'direction-standard',
  REVERSE: 'direction-reverse'
};